export default "__VITE_ASSET__0aSa1F0l__"